export default "__VITE_ASSET__Cmg6DBOq__"